import React from 'react';
import { OFFER_ANCHOR } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  external?: boolean;
  className?: string;
  subLabel?: string;
}
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  external = false,
  className = '',
  subLabel
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`block w-full rounded-lg border-b-4 border-[#3FA81C] bg-ev-green px-4 py-3 text-center font-sans text-[15px] font-extrabold uppercase leading-tight tracking-wide text-ev-black shadow-[0_8px_20px_-8px_rgba(116,240,68,0.8)] transition-transform duration-150 ease-out hover:scale-[1.02] active:translate-y-[2px] active:border-b-2 sm:text-lg ${className}`} data-id="element-38" data-mp="2fysbj00oyrqc">
      {children}
      {subLabel && <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-[0.12em] text-ev-black/70 sm:text-xs" data-id="element-39" data-mp="3cq3y8i7trlqu">
          {subLabel}
        </span>}
    </a>;
}